import { mapGetters } from 'vuex';
import { getStorage } from '../../../common/utilities/nojq/_localstorage.js';

export default {
    name: 'dppNav',
    data() {
        return {
            lastSearch: null,
        };
    },
    computed: {
        ...mapGetters('glb', ['glb']),
        ...mapGetters('dpp', ['geo', 'dpp']),
        backUrl() {
            const lastSearch = this.lastSearch;
            if (lastSearch?.url) {
                return `${this.glb.appUrl}${lastSearch.url.replace(/^\//, '')}`;
            } else if (this.dpp.geo.cityPath) {
                return `${this.glb.appUrl}${this.dpp.geo.cityPath}`;
            } else {
                return this.glb.appUrl;
            }
        },
    },
    mounted() {
        this.lastSearch = getStorage('lastSearch');
    },
};
